import React from 'react';

export default function ConnectFeature() {
  return (
    <div className="p-4 text-center">
      <h2 className="text-xl font-bold mb-2">Connect Feature</h2>
      <p className="text-gray-500">Live connection is currently unavailable. Please use the Private Chat Room or Community features for real-time chat.</p>
    </div>
  );
} 